import React, { Component, Fragment } from "react";

import classNames from "classnames";
import { generateId } from "../../shared/utils";
import i18n from "../../shared/i18n/i18n";

import FieldText from "../../SharedComponent/FieldText/FieldText";
import FieldDateTime from "../../SharedComponent/FieldDateTime/FieldDateTime";

export default class FieldSetIdentityCard extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.ui = {
      series: React.createRef(),
      number: React.createRef(),
      dateOfIssue: React.createRef(),
      authority: React.createRef(),
      insuranceNumber: React.createRef(),
    };

    this.setValue = this.setValue.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  setValue(data) {
    this.ui.series.current.setValue(data.series || "");
    this.ui.number.current.setValue(data.number || "");
    this.ui.dateOfIssue.current.setValue(data.dateOfIssue || "");
    this.ui.authority.current.setValue(data.authority || "");
    this.ui.insuranceNumber.current.setValue(data.insuranceNumber || "");
  }

  getValue() {
    return {
      series: this.ui.series.current.getValue(),
      number: this.ui.number.current.getValue(),
      dateOfIssue: this.ui.dateOfIssue.current.getValue(),
      authority: this.ui.authority.current.getValue(),
      insuranceNumber: this.ui.insuranceNumber.current.getValue(),
    };
  }

  render() {
    return (
      <Fragment>
        <div className="fb-row">
          <FieldText
            ref={this.ui.series}
            setting={this.props.setting}
            option={{
              label: "SERIES",
              type: "text",
              value: "",
              size: 20,
              onChange: function (value) {
                return value.length <= 45;
              },
            }}
          />
          <FieldText
            ref={this.ui.number}
            setting={this.props.setting}
            option={{
              label: "NUMBER",
              type: "text",
              value: "",
              size: 20,
              onChange: function (value) {
                return value.length <= 45;
              },
            }}
          />
          <FieldDateTime
            ref={this.ui.dateOfIssue}
            setting={this.props.setting}
            option={{
              label: "DATE_OF_ISSUE",
            }}
          />
        </div>
        <FieldText
          ref={this.ui.authority}
          setting={this.props.setting}
          option={{
            label: "AUTHORITY",
            type: "text",
            value: "",
            onChange: function (value) {
              return value.length <= 300;
            },
          }}
        />
        <div className="fb-row">
          <FieldText
            ref={this.ui.insuranceNumber}
            setting={this.props.setting}
            option={{
              label: "INSURANCE_NUMBER",
              type: "text",
              value: "",
              onChange: function (value) {
                return value.length <= 50;
              },
            }}
          />
        </div>
      </Fragment>
    );
  }
}
